var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceFrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.3 399.3C130.8 396.7 126.1 387.7 128.7 379.3C145.2 326.1 196.3 288 256 288C315.8 288 366.8 326.1 383.3 379.3C385.9 387.7 381.2 396.7 372.7 399.3C364.3 401.9 355.3 397.2 352.7 388.7C340.5 349.4 302.1 320 256 320C209.9 320 171.5 349.4 159.3 388.7C156.7 397.2 147.7 401.9 139.3 399.3H139.3zM200.4 208C200.4 221.3 189.6 232 176.4 232C163.1 232 152.4 221.3 152.4 208C152.4 194.7 163.1 184 176.4 184C189.6 184 200.4 194.7 200.4 208zM312.4 208C312.4 194.7 323.1 184 336.4 184C349.6 184 360.4 194.7 360.4 208C360.4 221.3 349.6 232 336.4 232C323.1 232 312.4 221.3 312.4 208zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceFrown);
export default __webpack_public_path__ + "static/media/face-frown.8803d1cdfdf2880fca3a677db0dcbb8f.svg";
export { ForwardRef as ReactComponent };